import { render } from "./ViewServices.vue?vue&type=template&id=eef9f202"
import script from "./ViewServices.vue?vue&type=script&lang=js"
export * from "./ViewServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__